<template>
    <transition name="slide-fade">
        <div style="width: 95%;z-index: 9999;" v-if="visible" :class="notificationClass">
            <div class="d-flex p-1">
                <div class="pt-2 pl-2">
                    <i style="font-size: xx-large;" :class="iconClass"></i>
                </div>
                <div class="flex-grow-1 align-self-center pl-3">
                    <strong v-if="title" style="font-size: 16px;">{{ title }}<br></strong>
                    <span v-if="text">{{ text }}</span>
                </div>
                <div class="ml-auto align-self-center pt-1 pr-2">
                    <i style="font-size: large;" @click="closeNotification()" class="fi fi-rr-cross"></i>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        text: {
            type: String,
            required: true
        },
        color: {
            type: String,
            default: 'info',
            required: true

        }
    },
    data() {
        return {
            visible: false
        }
    },
    computed: {
        notificationClass() {
            return `notification-${this.color}`;
        },
        iconClass() {
            switch (this.color) {
                case 'success':
                    return 'fi fi-rr-badge-check'
                case 'warning':
                    return 'fi fi-rr-triangle-warning'
                case 'danger':
                    return 'fi fi-rr-light-emergency-on'
                case 'info':
                    return 'fi fi-rr-info '
                case 'notify':
                    return 'fi fi-rr-bell'
                default:
                    return 'fi fi-rr-badge-check'
                    break;
            }


        }
    },
    methods: {
        pushNotification() {
            this.visible = true;
            setTimeout(() => {
                this.visible = false;
            }, 3000)

        },
        closeNotification() {
            this.visible = false;
        }
    }
}
</script>

<style scoped>
.notification-success,
.notification-warning,
.notification-danger,
.notification-info,
.notification-notify {
    position: fixed;
    top: 20px;
    right: 10px;
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(47, 47, 47, 0.1);
    z-index: 1000;
    background-color: #f9f9f9;
    border-left: 6px solid;
    padding: 12px 16px;
}

.notification-success {
    color: #5cb007;
    /* original background color as text */
    border-color: #5cb007;
}

.notification-warning {
    color: #ff7b07;
    border-color: #ff7b07;
}

.notification-danger {
    color: #dc3545;
    border-color: #dc3545;
}

.notification-info {
    color: #2caad8;
    border-color: #2caad8;
}

.notification-notify {
    color: #404040;
    border-color: #404040;
}

.notification button {
    background: none;
    border: none;
    cursor: pointer;
    margin-top: 10px;
}

.slide-fade-enter-active {
    transition: transform 0.5s ease, opacity 0.5s ease;
}

.slide-fade-leave-active {
    transition: opacity 0.5s ease;
}

.slide-fade-enter {
    transform: translateX(100%);
    opacity: 0;
}

.slide-fade-leave-to {
    opacity: 0;
}
</style>
